import { controls, currencyToNumber, grouped } from "../../controls";

const rpad4 = {
  label: "Non-Compliance Report",
  starting: true,
  url: "rp101m",
  pageLabel: "Non-Compliance Report",
  pageType: "history",
  // filteraction: true,
  filter: [
    ...controls.displayText({ tab: "general", label: "Bank", star: true }),
    ...controls.oc({ tab: "general", length: 4, c: "Client", placeHolder: "Bank Code", name: "client_code", isRequired: true, fastpath: "clients", clearData: ["branch_code"] }),
    ...controls.showData({ tab: "general", displaytype: "capital", data: "client_display" }),


    ...controls.displayText({ tab: "general", label: "Branch", star: true }),
    ...controls.oc({
      tab: "general", length: 4, c: "Branch", placeHolder: "Branch Code", name: "branch_code", isRequired: true, fastpath: "branches",
      sendToServer: { sendData: [{ varname: "client.client_uid", value: "client_uid" }] }
    }),
    ...controls.showData({ tab: "general", displaytype: "capital", data: "branch_display" }),


    ...controls.displayText({ tab: "general", label: "Inspecting Officer", star: true }),
    ...controls.oc({ tab: "general", length: 4, c: "User", placeHolder: "Inspecting Officer Code", name: "user_code", isRequired: true, fastpath: "users" }),
    ...controls.showData({ tab: "general", displaytype: "capital", data: "user_display" }),
  ],
  form: [],
  history: {
    perPage: 50,
    reportHeader: "Non-Compliance Report",
    filterable: true,
    sortable: true,
    defaultsTo: 0,
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    extraRows: {
      location: "top",
      fields: ["observation_type"],
      subtotals: {
        by: "insgroup",
        displayIn: "observation_type",
        count: true
      }
      // grandtotal: { type: "fixed", displayIn: "pacs_name", val: "Grand Total", count: true },
    },

    displayColumns: [
      {
        Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30,
        width132: { size: 3 }
      },
      {
        Header: "Observation",
        accessor: "observation_type"
      },
      {
        Header: "Inspection Date",
        accessor: "date",
        type: "date"
      },
      {
        Header: "Status",
        accessor: "inspection_status"
      },
      {
        Header: "Remark",
        accessor: "remark"
      },
      {
        Header: "Complete By",
        accessor: "complete_by",
        type: "date"
      }
    ]
  }
};

export default rpad4;